import React from 'react'

import { t } from '@owl-nest/localize'

class InteractiveCountdown extends React.Component {
  state = {
    finished: false,
    days: 0,
    hours: 0,
    min: 0,
    sec: 0,
  }

  calculateCountdown(endDate) {
    let diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000

    // clear countdown when date is reached
    if (diff <= 0) return false

    const timeLeft = {
      years: 0,
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
      millisec: 0,
    }

    // calculate time difference between now and expected date
    if (diff >= 365.25 * 86400) {
      // 365.25 * 24 * 60 * 60
      timeLeft.years = Math.floor(diff / (365.25 * 86400))
      diff -= timeLeft.years * 365.25 * 86400
    }
    if (diff >= 86400) {
      // 24 * 60 * 60
      timeLeft.days = Math.floor(diff / 86400)
      diff -= timeLeft.days * 86400
    }
    if (diff >= 3600) {
      // 60 * 60
      timeLeft.hours = Math.floor(diff / 3600)
      diff -= timeLeft.hours * 3600
    }
    if (diff >= 60) {
      timeLeft.min = Math.floor(diff / 60)
      diff -= timeLeft.min * 60
    }

    timeLeft.sec = diff

    return timeLeft
  }

  tick(date) {
    if (!date) return

    this.setState(date)
  }

  stop() {
    clearInterval(this.interval)
    this.setState({ finished: true })
  }

  componentDidMount() {
    const date = this.calculateCountdown(this.props.date)
    this.tick(date)

    // update every second
    this.interval = setInterval(() => {
      const date = this.calculateCountdown(this.props.date)

      if (date) {
        this.tick(date)
      } else {
        this.stop()
      }
    }, 1000)
  }

  componentWillUnmount() {
    this.stop()
  }

  addLeadingZeros(value) {
    value = String(value)
    while (value.length < 2) {
      value = '0' + value
    }
    return value
  }

  render() {
    const { fallback } = this.state
    const { finished, min, sec } = this.state

    if (finished) {
      return <span>{fallback}</span>
    }

    return (
      <span>
        {t('%(min)s min %(sec)s sec', {
          min: this.addLeadingZeros(min),
          sec: this.addLeadingZeros(sec),
        })}
      </span>
    )
  }
}

export default InteractiveCountdown
